module.exports = __webpack_public_path__ + "img/uimaranta_original.7f444b5a.jpg";